import type { FacetData } from '~/contracts/common';
import { isDefined } from '~/utilities/array';
import { logError } from '~/utilities/loggers';

export default function getCvnaFeatureNames(
  facetData: Partial<FacetData>,
  ids: string[] = []
): string[] {
  try {
    const items = Object.values(facetData.cvnaFeatureDetails ?? {}).flat();

    return ids
      .map(id => items.find(item => item.key === id)?.displayName)
      .filter(isDefined);
  } catch (error) {
    logError(error, { ids, location: 'getCvnaFeatureNames' });

    return [];
  }
}
